import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const brandApi = createApi({
  reducerPath: 'brandApi',
  baseQuery: createBaseQuery('brands'),
  tagTypes: ['Brand'],
  endpoints: builder => ({
    getBrand: builder.query({
      query: id => `/${id}`,
      transformResponse: ({ result }) => result,
      providesTags: (result, error, id) => [{ type: 'Brand', id }],
    }),
    updateBrandEmailTemplateLinks: builder.mutation({
      query: ({ id, ...links }) => ({
        url: `/${id}/email_template_links`,
        method: 'PUT',
        body: links,
      }),
      transformResponse: ({ result }) => result,
      invalidatesTags: (result, error, { id }) => [{ type: 'Brand', id }],
    }),
  }),
});

export const { useLazyGetBrandQuery, useUpdateBrandEmailTemplateLinksMutation } = brandApi;
